import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

export type GetExecutionParams = {
  id: string;
};

export const performGetExecutions = async (api: IApiStore, params: EndpointCallParams<{}>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('neoanalytics-app/api/v1/executions/query', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}
export const performGetExecutionsFullData = async (api: IApiStore, params: EndpointCallParams<{}>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('neoanalytics-app/api/v1/executions/query?fullData=true', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}

export const performGetExecution = async (api: IApiStore, params: EndpointCallParams<GetExecutionParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .get(`neoanalytics-app/api/v1/executions/${payload.id}`, {
            ...rest,
            payload: { ...payload },
        })

    return req;
}